<template>
    <vPersonPerformanceConfirmComponent :postList="postList" v-if="flag"></vPersonPerformanceConfirmComponent>
</template>
<script>
import vPersonPerformanceConfirmComponent from '@/components/page/listComponent/basicdata/performance/personPerformanceConfirmComponent.vue';
export default {
    name: 'person_performance_confirm',
    components: {
        vPersonPerformanceConfirmComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                parent_code: true,
                setBtn: true,
                person_performance_id: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>